export {
  Table as BaseTable,
  TableRoot,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableColumnHeader,
  TableCaption,
} from './table';
export type {
  TableProps,
  TableHeaderProps,
  TableBodyProps,
  TableRowProps,
  TableCellProps,
  TableCaptionProps,
} from './table';

// Compound Table component for dot notation usage (Table.Root, Table.Header, etc.)
import {
  Table as TableComponent,
  TableRoot,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableColumnHeader,
  TableCaption,
} from './table';
export const Table = Object.assign(TableComponent, {
  Root: TableRoot,
  Header: TableHeader,
  Body: TableBody,
  Row: TableRow,
  Cell: TableCell,
  Head: TableHead,
  ColumnHeader: TableColumnHeader,
  Caption: TableCaption,
});
